import {
	patchMarketsMarketIdVerticalsVerticalIdSettingsGeneral,
	type VerticalGeneralSetupUpdateDto,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { getGeneralSetupQueryKey } from "Settings/Modules/GeneralSetup/Api/Query/useGeneralSetupQuery";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const generalSetupResource = Resources.base.generalSetup.mutation;

type VerticalGeneralSetupUpdateWithAllocation =
	VerticalGeneralSetupUpdateDto & {
		allocationMaxDrivingDistanceKm?: number | null;
	};

export const useUpdateGeneralSetupMutation = (
	marketId: number,
	verticalId: number,
) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(
			(data: VerticalGeneralSetupUpdateWithAllocation) =>
				patchMarketsMarketIdVerticalsVerticalIdSettingsGeneral(
					data,
					marketId,
					verticalId,
				),
		),
		onError: (error) => {
			console.error(
				`${t(generalSetupResource.updateGeneralSetupError)}: ${error}`,
			);
		},
		onSuccess: () => {
			toast.success(`${t(generalSetupResource.updateGeneralSetupSuccess)}`);
			queryClient.invalidateQueries({
				queryKey: getGeneralSetupQueryKey(marketId, verticalId),
			});
		},
	});
};
